<button
  type="button"
  (click)="onClick($event)"
  [disabled]="disabled()"
  [ngClass]="{
    'text-primary-600 hover:text-primary-900': type() === 'edit',
    'text-primary-500 hover:text-red-600': type() === 'delete',
  }"
>
  <i class="material-symbols-outlined">{{ icon() }}</i>
</button>
